import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "poll-modal"
}
const _hoisted_2 = { class: "poll-modal__header" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "poll-modal__summary" }
const _hoisted_5 = {
  key: 0,
  class: "poll-modal__options"
}
const _hoisted_6 = {
  key: 1,
  class: "results__options"
}
const _hoisted_7 = { class: "results__option-title" }
const _hoisted_8 = {
  key: 0,
  class: "percentage"
}
const _hoisted_9 = {
  key: 0,
  class: "results__option__details"
}
const _hoisted_10 = {
  key: 1,
  class: "results__option-subtitle"
}
const _hoisted_11 = {
  key: 2,
  class: "poll-modal__actions"
}
const _hoisted_12 = {
  key: 3,
  class: "poll-modal__actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconPoll = _resolveComponent("IconPoll")
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")
  const _component_PollVotersDetails = _resolveComponent("PollVotersDetails")
  const _component_IconCheck = _resolveComponent("IconCheck")
  const _component_NcProgressBar = _resolveComponent("NcProgressBar")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconFileEditOutline = _resolveComponent("IconFileEditOutline")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_NcActionLink = _resolveComponent("NcActionLink")
  const _component_IconFileLockOutline = _resolveComponent("IconFileLockOutline")
  const _component_NcActions = _resolveComponent("NcActions")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_NcModal = _resolveComponent("NcModal")

  return ($setup.id)
    ? (_openBlock(), _createBlock(_component_NcModal, {
        key: 0,
        size: "small",
        "label-id": $setup.dialogHeaderId,
        onClose: $options.dismissModal
      }, {
        default: _withCtx(() => [
          ($setup.poll)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_IconPoll, { size: 20 }),
                  _createElementVNode("span", {
                    id: $setup.dialogHeaderId,
                    role: "heading",
                    "aria-level": "2"
                  }, _toDisplayString($setup.name), 9, _hoisted_3)
                ]),
                _createElementVNode("p", _hoisted_4, _toDisplayString($options.pollSummaryText), 1),
                ($setup.modalPage === 'voting')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.poll.options, (option, index) => {
                        return (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
                          key: 'option-' + index,
                          modelValue: $options.checked,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.checked) = $event)),
                          value: index.toString(),
                          type: $options.isMultipleAnswers ? 'checkbox' : 'radio',
                          name: "answerType"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "value", "type"]))
                      }), 128))
                    ]))
                  : ($setup.modalPage === 'results')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.poll.options, (option, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "results__option"
                          }, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("p", null, _toDisplayString(option), 1),
                              ($options.hasVotesToDisplay)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($options.votePercentage[index] + '%'), 1))
                                : _createCommentVNode("", true)
                            ]),
                            ($options.getFilteredDetails(index).length > 0 || $options.selfHasVotedOption(index))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  ($setup.poll.details)
                                    ? (_openBlock(), _createBlock(_component_PollVotersDetails, {
                                        key: 0,
                                        token: $setup.token,
                                        details: $options.getFilteredDetails(index)
                                      }, null, 8, ["token", "details"]))
                                    : _createCommentVNode("", true),
                                  ($options.selfHasVotedOption(index))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                        _createVNode(_component_IconCheck, { size: 16 }),
                                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'You voted for this option')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            ($options.hasVotesToDisplay)
                              ? (_openBlock(), _createBlock(_component_NcProgressBar, {
                                  key: 1,
                                  class: "results__option-progress",
                                  value: $options.votePercentage[index],
                                  size: "medium"
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                ($options.isPollOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      ($setup.modalPage === 'voting')
                        ? (_openBlock(), _createBlock(_component_NcButton, {
                            key: 0,
                            variant: "primary",
                            disabled: $options.disabled,
                            onClick: $options.submitVote
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.t('spreed', 'Submit vote')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : (_openBlock(), _createBlock(_component_NcButton, {
                            key: 1,
                            variant: "secondary",
                            onClick: _cache[1] || (_cache[1] = $event => ($setup.modalPage = 'voting'))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.t('spreed', 'Change your vote')), 1)
                            ]),
                            _: 1
                          })),
                      ($options.canEndPoll)
                        ? (_openBlock(), _createBlock(_component_NcActions, {
                            key: 2,
                            "force-menu": ""
                          }, {
                            default: _withCtx(() => [
                              ($setup.supportPollDrafts && $options.isModerator)
                                ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                    key: 0,
                                    onClick: $options.createPollDraft
                                  }, {
                                    icon: _withCtx(() => [
                                      _createVNode(_component_IconFileEditOutline, { size: 20 })
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Save as draft')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              ($setup.supportPollDrafts)
                                ? (_openBlock(), _createBlock(_component_NcActionLink, {
                                    key: 1,
                                    href: $setup.exportPollURI,
                                    download: $setup.exportPollFileName
                                  }, {
                                    icon: _withCtx(() => [
                                      _createVNode(_component_NcIconSvgWrapper, {
                                        svg: $setup.IconFileDownload,
                                        size: 20
                                      }, null, 8, ["svg"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Export draft to file')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["href", "download"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_NcActionButton, {
                                class: "critical",
                                onClick: $options.endPoll
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_IconFileLockOutline, { size: 20 })
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($options.t('spreed', 'End poll')) + " ", 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : ($setup.supportPollDrafts && $options.selfIsOwnerOrModerator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_NcActions, { "force-menu": "" }, {
                          default: _withCtx(() => [
                            ($options.isModerator)
                              ? (_openBlock(), _createBlock(_component_NcActionButton, {
                                  key: 0,
                                  onClick: $options.createPollDraft
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_IconFileEditOutline, { size: 20 })
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Save as draft')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_NcActionLink, {
                              href: $setup.exportPollURI,
                              download: $setup.exportPollFileName
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_NcIconSvgWrapper, {
                                  svg: $setup.IconFileDownload,
                                  size: 20
                                }, null, 8, ["svg"])
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Export draft to file')), 1)
                              ]),
                              _: 1
                            }, 8, ["href", "download"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_NcLoadingIcon, {
                key: 1,
                class: "poll-modal__loading"
              }))
        ]),
        _: 1
      }, 8, ["label-id", "onClose"]))
    : _createCommentVNode("", true)
}